import { render, staticRenderFns } from "./IndexSHS.vue?vue&type=template&id=54a954fc&scoped=true"
import script from "./IndexSHS.vue?vue&type=script&lang=js"
export * from "./IndexSHS.vue?vue&type=script&lang=js"
import style0 from "./IndexSHS.vue?vue&type=style&index=0&id=54a954fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a954fc",
  null
  
)

export default component.exports